import {
  IPracticeMigration,
  ISourceLinkOption,
} from '@principle-theorem/practice-migrations/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { IBaseMigrationAppointmentBook } from '../../../interfaces';
import { AppointmentBookToPractitionerMappingHandler } from '../../../mappings/appointment-book-to-practitioner';
import {
  CalendarSourceEntity,
  CorePracticeCalendar,
  ICorePracticeCalendar,
} from '../../source/entities/calendars';
import { CorePracticeStafferMappingHandler } from './staff';

export class CorePracticeAppointmentBookToPractitionerMappingHandler extends AppointmentBookToPractitionerMappingHandler<
  CorePracticeCalendar,
  CalendarSourceEntity
> {
  sourceEntity = new CalendarSourceEntity();
  translateFn = (
    record: ICorePracticeCalendar
  ): IBaseMigrationAppointmentBook => ({
    id: record.id.toString(),
    description: record.description,
  });

  override async getSourceLinkOptions(
    migration: WithRef<IPracticeMigration>
  ): Promise<ISourceLinkOption[]> {
    const handler = new CorePracticeStafferMappingHandler();
    const options = await handler.getSourceOptions(migration);

    const omitOption = {
      value: '0',
      label: 'Omit',
    };
    return [omitOption, ...options].map((option) => ({
      sourceIdentifier: option.value,
      sourceLabel: option.label,
      resourceType: handler.sourceEntity.sourceEntity.metadata.idPrefix,
    }));
  }
}
